import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/dashboard-pages.css';

const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [notificationsEmail, setNotificationsEmail] = useState(true);
  const [notificationsTraining, setNotificationsTraining] = useState(true);
  const [notificationsWeekly, setNotificationsWeekly] = useState(false);
  const [theme, setTheme] = useState('light');
  const [language, setLanguage] = useState('en');

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <h1>Settings</h1>
        <p>Manage your account preferences and settings</p>
      </div>

      <div className="page-sections">
        <section className="section-card">
          <h2>Profile Information</h2>
          <div className="settings-form">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" placeholder="Your full name" defaultValue={user?.user_metadata?.name || ''} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="Your email" defaultValue={user?.email || ''} disabled />
              <small>Email cannot be changed</small>
            </div>
            <div className="form-group">
              <label>Company</label>
              <input type="text" placeholder="Your company" defaultValue={user?.user_metadata?.company || ''} />
            </div>
            <button className="action-btn primary">Save Changes</button>
          </div>
        </section>

        <section className="section-card">
          <h2>Security</h2>
          <div className="settings-form">
            <div className="form-group">
              <label>Change Password</label>
              <input type="password" placeholder="Current password" />
              <input type="password" placeholder="New password" style={{ marginTop: '8px' }} />
              <input type="password" placeholder="Confirm new password" style={{ marginTop: '8px' }} />
              <button className="action-btn secondary">Update Password</button>
            </div>
            <div className="form-group">
              <label>Two-Factor Authentication</label>
              <div style={{ marginTop: '8px' }}>
                <button className="action-btn secondary">Enable 2FA</button>
              </div>
              <small>Enhance your account security with two-factor authentication</small>
            </div>
          </div>
        </section>

        <section className="section-card">
          <h2>Notifications</h2>
          <div className="settings-toggles">
            <div className="toggle-item">
              <div className="toggle-label">
                <div>Email Notifications</div>
                <small>Receive email updates about your projects</small>
              </div>
              <input
                type="checkbox"
                checked={notificationsEmail}
                onChange={(e) => setNotificationsEmail(e.target.checked)}
              />
            </div>
            <div className="toggle-item">
              <div className="toggle-label">
                <div>Training Alerts</div>
                <small>Notify me when training is complete</small>
              </div>
              <input
                type="checkbox"
                checked={notificationsTraining}
                onChange={(e) => setNotificationsTraining(e.target.checked)}
              />
            </div>
            <div className="toggle-item">
              <div className="toggle-label">
                <div>Weekly Summary</div>
                <small>Get a weekly digest of your activity</small>
              </div>
              <input
                type="checkbox"
                checked={notificationsWeekly}
                onChange={(e) => setNotificationsWeekly(e.target.checked)}
              />
            </div>
          </div>
        </section>

        <section className="section-card">
          <h2>Preferences</h2>
          <div className="settings-form">
            <div className="form-group">
              <label>Theme</label>
              <select value={theme} onChange={(e) => setTheme(e.target.value)}>
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="auto">Auto (based on system)</option>
              </select>
            </div>
            <div className="form-group">
              <label>Language</label>
              <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                <option value="en">English</option>
                <option value="es">Spanish</option>
                <option value="fr">French</option>
                <option value="de">German</option>
                <option value="zh">Chinese</option>
              </select>
            </div>
          </div>
        </section>

        <section className="section-card">
          <h2>Connected Applications</h2>
          <div className="apps-list">
            <div className="app-item">
              <div className="app-info">
                <div className="app-icon">🔌</div>
                <div className="app-details">
                  <div className="app-name">GitHub</div>
                  <div className="app-status">Connected • Oct 15, 2025</div>
                </div>
              </div>
              <button className="action-btn secondary">Disconnect</button>
            </div>
            <div className="app-item">
              <div className="app-info">
                <div className="app-icon">☁️</div>
                <div className="app-details">
                  <div className="app-name">Google Drive</div>
                  <div className="app-status">Not connected</div>
                </div>
              </div>
              <button className="action-btn secondary">Connect</button>
            </div>
          </div>
        </section>

        <section className="section-card">
          <h2>Data & Privacy</h2>
          <div className="settings-form">
            <div className="form-group">
              <button className="action-btn secondary">📥 Download My Data</button>
              <small>Download all your personal data in JSON format</small>
            </div>
            <div className="form-group">
              <button className="action-btn secondary">🗑️ Delete All Projects</button>
              <small>Permanently delete all your projects and data</small>
            </div>
          </div>
        </section>

        <section className="section-card danger-zone">
          <h2 style={{ color: '#c33' }}>Danger Zone</h2>
          <div className="settings-form">
            <div className="form-group">
              <label style={{ color: '#c33' }}>Delete Account</label>
              <p>Permanently delete your account and all associated data. This action cannot be undone.</p>
              <button className="action-btn" style={{ background: '#c33', color: 'white' }}>
                Delete Account
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SettingsPage;
